import {checkIsMobileOrTablet, clientUserAgent} from '@/core/plugins/checkDeviceType';

export default {
    bind(el, binding) {
        const isMobileOrTablet = checkIsMobileOrTablet(clientUserAgent);
        if (isMobileOrTablet || !binding.value) {
            return;
        }

        el.addEventListener('mouseenter', _createTooltip(el, binding));
        el.addEventListener('mouseleave', _removeExistedTooltip(el, binding));
        window.addEventListener('scroll', _removeExistedTooltip(el, binding));
    },
    unbind(el, binding) {
        el.removeEventListener('mouseenter', _createTooltip(el, binding));
        el.removeEventListener('mouseleave', _removeExistedTooltip(el, binding));
        window.removeEventListener('scroll', _removeExistedTooltip(el, binding));
    },
};

const TOP_POSITION_OFFSET = 27;
const LEFT_POSITION_OFFSET = 12;

/**
 * @param {HTMLElement} element
 * @param {String} {value}
 * @returns {() => void}
 * @private
 */
function _createTooltip(element, {value}) {
    return function() {
        if (!value || !element) {
            return;
        }

        if (document.querySelector('#custom-tooltip')) {
            return;
        }

        const tooltip = document.createElement('span');
        tooltip.textContent = value;
        tooltip.setAttribute('id', 'custom-tooltip');
        tooltip.setAttribute('class', 'custom-tooltip');
        element.insertAdjacentElement('beforebegin', tooltip);
        const {left, top} = element.getBoundingClientRect();
        tooltip.style.top = `${top - TOP_POSITION_OFFSET}px`;
        tooltip.style.left = `${left - (tooltip.offsetWidth / 2 - LEFT_POSITION_OFFSET)}px`;
    };
};

/**
 * @param {HTMLElement} element
 * @param {String} {value}
 * @returns {() => void}
 * @private
 */
function _removeExistedTooltip(element, {value}) {
    return function() {
        if (!value || !element) {
            return;
        }

        const tooltip = document.getElementById('custom-tooltip');
        tooltip && tooltip.remove();
    };
};
